export const isSkuForbiddenToAddToCart = (sku: string) => sku.startsWith('GWP-') || sku === 'WSBOX'

export const oncePerBasket = (sku: string) => sku.startsWith('WSBOX') || sku === '1234'
